import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-services',
  templateUrl: './user-services.component.html',
  styleUrls: ['./user-services.component.scss']
})
export class UserServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
